import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";
import React from "react";

export interface ILoader {
  blur?: boolean;
  position?: "center" | "absolute" | "default";
  size?: number;
}

const LoaderWrapper = styled("div")<ILoader>(({ position, blur }) => {
  if (position === "default") {
    return {};
  }

  return {
    backdropFilter: position === "absolute" && blur ? "blur(1px)" : undefined,
    width: "100%",
    height: "100%",
    position: position === "center" ? "relative" : "absolute",
    left: position === "center" ? "unset" : "0",
    top: position === "center" ? "unset" : "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
  };
});

export const Loader: React.FC<ILoader> = ({
  position = "default",
  size,
  blur,
}) => {
  return (
    <LoaderWrapper position={position} blur={blur}>
      <CircularProgress size={size} />
    </LoaderWrapper>
  );
};
